import { isEmpty } from "lodash";
import httpAdapter, { ApiVersion, HttpMethod } from "../../utils/http-adaper";

const DashboardWidgetService = {
  getPaymentHistoryBreakdown: async ({ startDate, endDate, promoCode }) => {
    const queryParams = {
      from: startDate,
      to: endDate,
    };
    if (!isEmpty(promoCode)) {
      queryParams.promoCode = promoCode;
    }
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "admin/payment_stats",
      authneticated: true,
      queryParams,
    });
  },
  getSubscriptionDashboardData: async ({ startDate, endDate }) => {
    const queryParams = {
      from: startDate,
      to: endDate,
    };
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "admin/subscription_stats",
      authneticated: true,
      queryParams,
    });
  },
  getSubscriptionChargeAttempts: async ({ from, to, memberId }) => {
    const queryParams = {};
    if (!isEmpty(from)) queryParams.from = from;
    if (!isEmpty(to)) queryParams.to = to;
    if (!isEmpty(memberId)) queryParams.memberId = memberId;
    console.log(">>>>> queryParams >>>> ", queryParams);

    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "admin/posts/charge_attempts",
      authneticated: true,
      queryParams,
    });
  },
  getSubscriptionExpirations: async ({ from, to }) => {
    const queryParams = {};
    if (!isEmpty(from)) queryParams.from = from;
    if (!isEmpty(to)) queryParams.to = to;
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "operator/users/subscription_expiring",
      authneticated: true,
      queryParams,
    });
  },
  searchPosts: async ({ searchParams = {} }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "operator/search_posts",
      authneticated: true,
      queryParams: searchParams,
    });
  },
  getSystemStat: async ({ fromDate, toDate }) => {
    return await httpAdapter.request({
      method: HttpMethod.GET,
      apiVersion: ApiVersion.V1,
      path: "admin/system_stats",
      authneticated: true,
      queryParams: {
        from: fromDate,
        to: toDate,
      },
    });
  },
};

export default DashboardWidgetService;
